import * as FullStory from '@fullstory/browser'
import {FULLSTORY_ORG, FULLSTORY_NAMESPACE, ENV} from '../../config/envConfig'

// Extend Window interface to include FullStory properties
declare global {
  interface Window {
    _fs_namespace?: string
    _fs_org?: string
  }
}

/**
 * Initialize FullStory with the configuration from environment variables
 */
export const initFullStory = (): void => {
  // Only initialize if we have a valid org ID (not empty)
  const isValidOrgId = FULLSTORY_ORG && FULLSTORY_ORG.trim() !== ''

  if (isValidOrgId) {
    try {
      // Set the global namespace for backward compatibility
      window._fs_namespace = FULLSTORY_NAMESPACE
      window._fs_org = FULLSTORY_ORG

      // Initialize FullStory
      FullStory.init(
        {
          orgId: FULLSTORY_ORG,
          namespace: FULLSTORY_NAMESPACE || 'FS',
        },
        ({sessionUrl}) => {
          console.log(`FullStory session started: ${sessionUrl}`)
        },
      )

      // Set environment info - using the correct typing
      // @ts-ignore - The FullStory types are incorrect, setVars accepts an object
      FullStory.setVars({
        environment_str: ENV,
      })

      console.log('FullStory initialized with org ID:', FULLSTORY_ORG)
    } catch (error) {
      console.error('Error initializing FullStory:', error)
    }
  } else {
    console.log('FullStory not initialized: Missing, empty, or placeholder org ID', {orgId: FULLSTORY_ORG})
  }
}

export default initFullStory
